import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueMoment from 'vue-moment';
import * as moment from 'moment-timezone';
import * as momentDurationFormatSetup from 'moment-duration-format';
import {library} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon, FontAwesomeLayers} from '@fortawesome/vue-fontawesome';
import BootstrapVue from 'bootstrap-vue';
import VueMask from 'v-mask';
import money from 'v-money';

import {CurrencyFilter} from '@/filters/currency';
import {PhoneNumberFilter} from '@/filters/phone-number';
import CompletedOverlay from '@/components/CompletedOverlay.vue';
import LoadingOverlay from '@/components/LoadingOverlay.vue';
import Overlay from '@/components/Overlay.vue';
import PhoneInput from '@/components/PhoneInput.vue';
import ItemOptions from '@/components/ItemOptions.vue';

// Solid icons (Import them directly to avoid including ALL icons in build)
import {faBadgeCheck} from '@fortawesome/pro-solid-svg-icons/faBadgeCheck';
import {faBars} from '@fortawesome/pro-solid-svg-icons/faBars';
import {faCheckCircle} from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import {faCaretUp} from '@fortawesome/pro-solid-svg-icons/faCaretUp';
import {faCaretDown} from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import {faPlus} from '@fortawesome/pro-solid-svg-icons/faPlus';
import {faAngleRight} from '@fortawesome/pro-solid-svg-icons/faAngleRight';
import {faAngleLeft} from '@fortawesome/pro-solid-svg-icons/faAngleLeft';
import {faShoppingCart} from '@fortawesome/pro-solid-svg-icons/faShoppingCart';
import {faArrowUp} from '@fortawesome/pro-solid-svg-icons/faArrowUp';
import {faArrowDown} from '@fortawesome/pro-solid-svg-icons/faArrowDown';

// Light icons (Import them directly to avoid including ALL icons in build)
import {faCircle} from '@fortawesome/pro-light-svg-icons/faCircle';
import {faTimes} from '@fortawesome/pro-light-svg-icons/faTimes';
import {faQrcode} from '@fortawesome/pro-light-svg-icons/faQrcode';
import {faSignOut} from '@fortawesome/pro-light-svg-icons/faSignOut';
import {faTrashAlt} from '@fortawesome/pro-light-svg-icons/faTrashAlt';
import {faEdit} from '@fortawesome/pro-light-svg-icons/faEdit';


library.add(
	faQrcode,
	faBadgeCheck,
	faBars,
	faCircle,
	faTimes,
	faCheckCircle,
	faCaretUp,
	faCaretDown,
	faPlus,
	faSignOut,
	faAngleRight,
	faAngleLeft,
	faTrashAlt,
	faShoppingCart,
	faEdit,
	faArrowUp,
	faArrowDown
);

momentDurationFormatSetup(moment);
Vue.use(VueMoment, {
	moment: moment,
});
Vue.use(BootstrapVue);
Vue.use(VueMask, {
	placeholders: {
		'#': null,       // passing `null` removes default placeholder, so `#` is treated as character
		D: /\d/,         // define new placeholder
	}
});
Vue.use(money, {
	decimal: '.',
	thousands: ',',
	prefix: '$',
	suffix: '',
	precision: 2
});

// Plugin components
Vue.component('fa-icon', FontAwesomeIcon);
Vue.component('fa-layers', FontAwesomeLayers);

// Common components
Vue.component('completed-overlay', CompletedOverlay);
Vue.component('loading-overlay', LoadingOverlay);
Vue.component('phone-input', PhoneInput);
Vue.component('overlay', Overlay);
Vue.component('item-options', ItemOptions); // Used 3 places

// Filters
Vue.filter('currency', CurrencyFilter);
Vue.filter('phoneNumber', PhoneNumberFilter);


Vue.config.productionTip = false;
// So you can throw "$log(...)" in a template to debug the value
Vue.prototype.$log = console.log;
new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app');
